import {ReservationStatus} from 'crqlar-react-common/dist/models/reservation/reservation.model';

const NEW_RESERVATION_STATUSES = [ReservationStatus.PENDING, ReservationStatus.CONFIRMED];
const EXISTING_RESERVATION_STATUSES = [
    ...NEW_RESERVATION_STATUSES,
    ReservationStatus.ACTIVE,
    ReservationStatus.COMPLETED,
    ReservationStatus.NO_SHOW,
    ReservationStatus.CANCELLED,
];

/** The dialog's status choices, retaining older statuses only while they are already selected. */
export const getReservationStatusOptions = (
    isExistingReservation: boolean,
    selected: readonly string[] = [],
): ReservationStatus[] => [
    ...(isExistingReservation ? EXISTING_RESERVATION_STATUSES : NEW_RESERVATION_STATUSES),
    ...[ReservationStatus.OPTION, ReservationStatus.UNCOMPLETED].filter(status => selected.includes(status)),
];
